//Empresa store
export const UPDATE_EMPRESAS = 'empresa/updateEmpresas';
export const UPDATE_EMPRESA = 'empresa/updateEmpresa';
export const SAVE_PAGINA = 'empresa/updatePagina';
export const EDIT_INVERSIONISTA = 'empresa/editInversionista';
export const EDIT_TRAMITADOR = 'empresa/editTramitador';

//tareas store
export const UPDATE_TAREAS = 'tareas/updateTareas';
export const UPDATE_TAREA = 'tareas/updateTarea';

//citas store
export const UPDATE_CITA = 'citas/updateCita';

//Usuarios store
export const UPDATE_USUARIOS = 'usuarios/updateUsuarios';
export const UPDATE_INFORMES = 'usuarios/updateInformes';
export const UPDATE_ROLES = 'usuarios/updateRoles';
export const UPDATE_PROFILE = 'usuarios/updateProfile';
export const ADD_USUARIO = 'usuarios/addUsuario';
export const EDIT_USUARIO = 'usuarios/editUsuario';
export const UPDATE_USUARIO = 'usuarios/updateUsuario';
export const ADD_USUARIO_MODAL = 'usuarios/addUsuarioModal';
export const DEACTIVATE_USUARIO = 'usuarios/deactivateUsuario';
export const ACTIVATE_USUARIO = 'usuarios/activateUsuario';

//Reportes store
export const UPDATE_REPORTES = 'reportes/updateReportes';
export const UPDATE_REPORTE = 'reportes/updateReporte';
export const UPDATE_TABS_STATUS = 'reportes/updateTabStatus';
export const UPDATE_CHANGE_PRICE = 'reportes/changePublicacion';
export const UPDATE_CHANGE_ESTADO_PRINCIPAL = 'reportes/changeEstadoPrincipal';
export const UPDATE_CHANGE_ESTADO_TRAMITE = 'reportes/changeEstadoTramite';
export const UPDATE_PAY_PLAN = 'reporte_inspeccion/changeInspeccionPlan';
export const UPDATE_ACTIVIDADES = 'reportes/updateActividades';
export const ADD_ACCION = 'reportes/addAccion';
//export const ADD_ARCHIVO = 'reportes/addArchivo';

//Conseguir
export const UPDATE_REPORTES_CONSEGUIR = 'conseguir/updateReportes';
export const UPDATE_CONSULTAS_CONSEGUIR = 'conseguir/updateReportesPerConsulta';
export const UPDATE_CONSEGUIR_MODAL = 'conseguir/updateReporte';
//Notifications
export const ADD_NOTIFICATION = 'notifications/addNotification'
export const SET_NOTIFICATION = 'notifications/setNotifications'
export const SET_NOTIFICATION_LIST = 'notifications/setNotificationsList'
export const UPDATE_NOTIFICATION = 'notifications/updateNotification'

//Cotizacion store
export const UPDATE_PRICE_COTIZACION = 'reportes/updatePriceCotizacion';

//Clientes store
export const UPDATE_CLIENTES = 'clientes/updateClientes';

//Fotos store
export const ADD_FOTO = 'fotosvideo/agregarFoto';
export const UPDATE_FOTOS = 'fotosvideo/updateFotos';
export const REMOVE_FOTO = 'fotosvideo/removeFoto';
export const UPDATE_VIDEO ='fotosvideo/updateVideo';

//Accesorios store
export const UPDATE_ACCESORIOS = 'accesorios/updateAccesorios';
export const UPDATE_ACC_COMFORT = 'accesorios/updateComfort';
export const UPDATE_ACC_SEGURIDAD = 'accesorios/updateseguridad';
export const UPDATE_ACC_EXTERIOR = 'accesorios/updateexterior';
export const UPDATE_ACC_MULTIMEDIA = 'accesorios/updatedmultimedia';

//Inventario store
export const UPDATE_INVENTARIO = 'inventario/updateCarros';
export const UPDATE_DETALLE = 'inventario/updateDetalle';

//Traspaso store
export const UPDATE_TRASPASO = 'traspaso/updateGastosCiudad';
export const UPDATE_FILTROS = 'inventario/updatemmyl';
export const DELETE_FILTER ='inventario/reboot';

//Embudo store
export const UPDATE_EMBUDO ='embudo/updateLeads';

//Inspeccion store
export const UPDATE_STEP = 'inspeccion/updateInspeccion';
export const UPDATE_INSPECCION_MECANICA = 'inspeccion/updateInspeccionMecanica';

//Reportes updates by tab
export const UPDATE_REPORTE_PANEL = 'reporte_panel/updatePanel';
export const UPDATE_EDIT_CLIENTE = 'reporte_panel/updateEditCliente';
export const UPDATE_CLIENTE_MODAL = 'reportes/updateClienteModal';
export const UPDATE_EDIT_VEHICULO = 'reporte_panel/updateEditVehiculo';
export const ADD_TAREA_PANEL = 'reporte_panel/addTarea';
export const ADD_CITA_PANEL = 'reporte_panel/addCita';
export const ADD_NOTA_PANEL = 'reporte_panel/addNota';
//export const ADD_ARCHIVO_PANEL = 'reporte_panel/addArchivo';
export const OPEN_MODAL_PANEL = 'reporte_panel/openModal';
export const OPEN_MODAL_EDIT_PANEL = 'reporte_panel/editModal';
export const RESET_TASK = 'reporte_panel/resetTarea';
export const OPEN_MODAL_EDIT_PANEL_CITA = 'reporte_panel/editModalCita';
export const RESET_CITA = 'reporte_panel/resetCita';
export const UPDATE_ACCION = 'reporte_panel/updateAccion';
export const UPDATE_OPERADORES = 'reporte_panel/updateOperadores';


export const UPDATE_REPORTE_COTIZACION = 'reporte_cotizacion/updateCotizacion';
export const UPDATE_REPORTE_DEPRECIACION = 'reporte_cotizacion/updateDepreciacion';
export const UPDATE_REPORTE_DEPRECIACION_CLEAN = 'reporte_cotizacion/removeDepreciacion';
export const UPDATE_REPORTE_ANO_MODAL ='reporte_cotizacion/updateAnoModal';
export const UPDATE_REPORTE_TITLE_MODAL ='reporte_cotizacion/updateTitleModal';
export const UPDATE_CHANGE_COMPONENTS = 'reportes/changeComponents';
export const UPDATE_CHANGE_TABS_ACTIVE = 'reportes/changeTabsStatus';

export const UPDATE_REPORTE_VEHICULO = 'reporte_vehiculo/updateVehiculo';
export const UPDATE_REPORTE_LEGAL = 'reporte_legal/updateLegal';

export const ADD_DOCUMENTO = 'reporte_panel/addDocumento';
export const REMOVE_DOCUMENTO = 'reporte_panel/removeDocumento';
export const UPDATE_DOCUMENTOS = 'reporte_panel/updateDocumentos';

export const UPDATE_REPORTE_INSPECCION = 'reporte_inspeccion/updateInspeccion';
export const UPDATE_REPORTE_GASTOS = 'reporte_gastos/updateGastos';
//export const ADD_IMPUESTOS = 'reporte_gastos/addImpuestos';
//export const REMOVE_IMPUESTOS = 'reporte_gastos/removeImpuestos';
//export const SAVE_IMPUESTOS = 'reporte_gastos/saveImpuestos';
export const CHANGE_YEAR = 'reporte_gastos/changeYear';
export const CHANGE_PRICE = 'reporte_gastos/changePrice';

export const UPDATE_REPORTE_PUBLICACION = 'reporte_publicacion/updatePublicacion';

export const UPDATE_REPORTE_FOTOSVIDEO = 'fotosvideo/updateFromReporte';
export const UPDATE_REPORTE_ACCESORIOS = 'accesorios/updateFromReporte';

export const UPDATE_GASTOS_FICHATECNICA = 'reporte_gastos/updateFromFichaTecnica';
export const UPDATE_GASTOS_REQUEST = 'reporte_gastos/updateFromRequest';
//
export const UPDATE_REPORTE_ID = 'reportes/updateReporteID';

export const UPDATE_INSPECCION_GENERAL = 'inspeccion_general/updateGeneral';
export const UPDATE_DATOS = 'inspeccion_general/updatedatos';
export const UPDATE_INSPECCION_REVISION = 'inspeccion_revision/updateRevision';
export const UPDATE_INSPECCION_ENCUESTA = 'inspeccion_encuesta/updateForm';

export const UPDATE_CONFIG = 'configuraciones/updateconfig';
export const UPDATE_CONTACTANOS = 'configuraciones/updatecontactanos';

//Prospecto store
export const UPDATE_PROSPECTO = 'prospecto_panel/updatePanel';
export const UPDATE_PROSPECTO_CREDITO = 'prospecto_panel/updatePanelCredito';

export const UPDATE_STEP_PROSPECTO = 'prospecto_panel/updateStep';
export const UPDATE_NECESIDAD_PROSPECTO = 'prospecto_necesidad/updateNecesidad';
export const UPDATE_CITA_PROSPECTO = 'prospecto_cita/updateCita';
export const UPDATE_POTENCIAL_PROSPECTO = 'prospecto_potencial/updatePotencial';
export const UPDATE_NEGOCIACION_PROSPECTO = 'prospecto_negociacion/updateNegociacion';
export const UPDATE_NEGOCIACION_DOCUMENTOS = 'prospecto_negociacion/updateDocumentos';

export const UPDATE_INSPECCION_PROSPECTO = 'prospecto_inspeccion/updateInspeccion';
export const UPDATE_CIERRE_PROSPECTO = 'prospecto_cierre/updateCierre';
export const CLONE_METODO_PAGO = 'prospecto_cierre/cloneMetodoPago';
export const UPDATE_STEP_LEAD = 'prospecto_panel/updateTabStep';

export const UPDATE_CREDITO_DATA = 'prospecto_necesidad/updateCredito';

//Credito store
export const UPDATE_STEP_CREDITO = 'credito_panel/updateStep';
export const UPDATE_PANEL_CREDITO = 'credito_panel/updatePanel';
export const UPDATE_CREDITOS = 'credito_panel/updateCreditos';

//Credito steps
export const UPDATE_STEPS_CREDITO = 'credito_steps/updateSteps';


//Buscador store
export const BUSCADOR_SET_MARCAS = 'buscador/setMarcas';
export const BUSCADOR_SET_MODELOS = 'buscador/setModelos';
export const BUSCADOR_SET_LINEAS = 'buscador/setLineas';
export const BUSCADOR_SET_VERSIONES = 'buscador/setVersiones';

//Sidebar

export const UPDATE_SIDEBAR = 'sidebar/updateSidebar';
export const ADD_CITA_SIDEBAR = 'sidebar/addCitaSidebar';
export const ADD_TAREA_SIDEBAR = 'sidebar/addTareaSidebar';

//Propuesta front data
export const UPDATE_PROPUESTA = 'propuesta/updatePropuesta';

//Comments
export const ADD_COMENTARIO = 'fichaTecnica/addComment';
export const UPDATE_COMENTARIOS = 'fichaTecnica/updateComments';

//Dashboard Store
export const UPDATE_CONTADORES = 'dashboard/updateContadores';
export const UPDATE_GESTION = 'dashboard/updateGestion';

//Adminventas
export const UPDATE_FACTURACION_MODAL = 'adminventa_modals/updateFacturacion';
export const UPDATE_RECAUDO_MODAL = 'adminventa_modals/updateRecaudo';
export const UPDATE_INGRESO_MODAL = 'adminventa_modals/updatePagar';
export const UPDATE_DOCUMENTO_MODAL = 'adminventa_modals/updateInputSlug';
export const UPDATE_CARPETA_ADMINVENTA = 'adminventa_carpeta/updateCarpetaAdminventa';
export const UPDATE_CARPETA_CONSIGNACION = 'adminventa_carpeta/updateCarpetaConsignacion';
export const UPDATE_CARPETA_CHEQUEOCARD = 'adminventa_carpeta/updateChequeoCard';
export const UPDATE_SOPORTES = 'adminventa_soportes/updateSoportes';
export const UPDATE_SOPORTE_MODAL = 'adminventa_soportes/updateSoporte';
export const UPDATE_ADMINVENTA_COMPRADOR = "proceso/updateAdminVentaComprador";

//Facturacion
export const UPDATE_FACTURACION = 'facturacion/updateFacturacion';

//Proceso layout
export const UPDATE_PROCESO_STEP = 'proceso/updateStep';
export const UPDATE_PROCESO_CHEQUEOCARD = 'proceso/updateChequeoCard';

export const UPDATE_PROCESO_SIDEBAR = 'proceso/updateSidebar';

export const UPDATE_PROCESO_ADMINVENTA = 'proceso/updateAdminVenta';

export const UPDATE_PROCESO_FICHAVENTA = 'ficha_panel/updateFichaVenta';

export const UPDATE_PROCESO_CONSIGNACION = 'proceso/updateConsignacion';
export const UPDATE_PROCESO_CONSIGNACION_DEPRECIACION = 'proceso/updateConsignacionDepreciacion';
export const UPDATE_PROCESO_CONSIGNACION_LIMITACIONES = 'proceso/updateConsignacionLimitaciones';

export const UPDATE_PROCESO_INSPECCION = 'proceso/updateInspeccion';

export const UPDATE_PROCESO_INVENTARIO = 'proceso/updateInventario';

export const UPDATE_PROCESO_RETOMA = 'proceso/updateRetoma';

export const UPDATE_PROCESO_VENTAS = 'proceso/updateVenta';
export const UPDATE_PROCESO_SERVICIO = 'proceso/updateServicio';

export const UPDATE_PROCESO_CREDITO = 'proceso/updateCredito';

export const ADD_IMPUESTOS = 'proceso/addImpuestos';
export const REMOVE_IMPUESTOS = 'proceso/removeImpuestos';
export const SAVE_IMPUESTOS = 'proceso/saveImpuestos';

export const ADD_MULTAS = 'proceso/addMultas';
export const REMOVE_MULTAS = 'proceso/removeMultas';
export const SAVE_MULTAS = 'proceso/saveMultas';

export const UPDATE_ID_NECESIDAD = 'ventas/updateProceso';
export const ADD_PROCESO_NECESIDAD = 'ventas/addProceso';

export const UPDATE_PROCESO_MODAL = 'ventas/openProceso';
export const UPDATE_PROCESO_CLOSE_MODAL = 'ventas/closeProceso';
export const UPDATE_MODAL_STEP = 'ventas/updateStep';

export const ADD_ITEMS = 'proceso/addItems';
export const REMOVE_ITEMS = 'proceso/removeItems';
export const SAVE_ITEMS = 'proceso/saveItems';

export const MODAL_UPDATE = 'modal/actualizarIndex';

export const GET_SEDES = 'helper/getSedes';






